<template>
    <rkm-area
        title="Ocupação - CBO"
        type="fieldset"
    >
        <Form :data="data" />
        <List :data="data" />
    </rkm-area>
</template>

<script>

// Components.
import List from './List'
import Form from './Form'

export default {
    components: { List, Form },
    props: {
        data: { type: Object, required: true },
    },
}
</script>